import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UseCase, mappingResultError } from '@digibricks/core';
import { Section } from '../../../../core';
export var UPDATE_SECTION_USE_CASE = 'UPDATE_SECTION_USE_CASE';
export var UpdateSectionUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(UpdateSectionUseCase, _UseCase);

  var _super = _createSuper(UpdateSectionUseCase);

  function UpdateSectionUseCase() {
    _classCallCheck(this, UpdateSectionUseCase);

    return _super.call(this);
  }

  _createClass(UpdateSectionUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(useCaseInput) {
        var updatedSectionOrError, updatedSection;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                updatedSectionOrError = this.updateSection(useCaseInput);

                if (!updatedSectionOrError.isFailure) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", mappingResultError(updatedSectionOrError));

              case 3:
                updatedSection = updatedSectionOrError.getValue();
                return _context.abrupt("return", Result.ok(updatedSection));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }, {
    key: "updateSection",
    value: function updateSection(input) {
      var updatingPayload = input.data,
          currentSection = input.currentSection;
      var curSection = Section.cloneTo(currentSection);
      var title = updatingPayload.title,
          description = updatingPayload.description,
          index = updatingPayload.index;
      var updatedResults = [];

      if (title) {
        updatedResults.push(curSection.updateTitle(title));
      }

      if (description) {
        updatedResults.push(curSection.updateDescription(description));
        var imgTagRegex = /<img[^>]*>/g;
        var imagesInDescription = description.match(imgTagRegex);
        var urls = imagesInDescription === null || imagesInDescription === void 0 ? void 0 : imagesInDescription.map(function (i) {
          // eslint-disable-next-line no-useless-escape
          var regex = /(?<=src=\")([^\"]+)/;
          var match = regex.exec(i);

          if (match) {
            return match[1];
          }
        });

        if (urls) {
          var foundFiles = curSection.files.filter(function (f) {
            return urls.find(function (u) {
              return u === f.url;
            });
          });
          curSection.updateFiles(foundFiles);
        } else {
          curSection.updateFiles([]);
        }
      }

      var updatedSectionResult = this.updateExtendedSection(input);

      if (updatedSectionResult.isFailure) {
        return mappingResultError(updatedSectionResult);
      }

      var resultCombine = Result.combine(updatedResults);

      if (resultCombine.isFailure) {
        return mappingResultError(resultCombine);
      }

      return Result.ok(curSection);
    }
  }, {
    key: "updateExtendedSection",
    value: function updateExtendedSection(input) {
      return Result.ok(input.currentSection);
    }
  }]);

  return UpdateSectionUseCase;
}(UseCase);